import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18n/en.json';
import ar from './i18n/ar.json';
import zhHans from './i18n/zh-Hans.json';

const SUPPORTED_LANGUAGES = ['en', 'ar', 'zh-Hans'];

const getInitialLanguage = () => {
  try {
    const saved = localStorage.getItem('lang');
    return SUPPORTED_LANGUAGES.includes(saved) ? saved : 'ar';
  } catch (_) {
    return 'ar';
  }
};

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  'zh-Hans': { translation: zhHans },
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: 'ar',
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: { escapeValue: false },
});

export default i18n;
